import { useState } from 'react';

const services = [
  {
    icon: 'ri-global-line',
    title: 'Webサイト制作・運営',
    description: 'ブランドの魅力を最大限に引き出す、美しく機能的なWebサイトを制作。SEO対策から継続的な運営サポートまで一貫して対応します。',
    color: 'from-yellow-400/20 to-yellow-400/5',
    tag: 'Web Design',
  },
  {
    icon: 'ri-code-s-slash-line',
    title: 'Webアプリケーション開発',
    description: 'ビジネスの課題を解決するカスタムWebアプリを開発。最新技術を活用し、スケーラブルで保守性の高いシステムを構築します。',
    color: 'from-orange-400/20 to-orange-400/5',
    tag: 'Development',
  },
  {
    icon: 'ri-settings-3-line',
    title: '情報システムの企画・開発・運用',
    description: '業務効率化を実現する情報システムを企画段階から運用まで一貫してサポート。お客様のニーズに合わせた最適なシステムを提供します。',
    color: 'from-yellow-500/20 to-yellow-500/5',
    tag: 'System',
  },
  {
    icon: 'ri-router-line',
    title: 'ネットワーク構築・保守',
    description: '安定した通信環境の構築から日常的な保守管理まで対応。セキュアで高速なネットワーク環境でビジネスの基盤を支えます。',
    color: 'from-amber-400/20 to-amber-400/5',
    tag: 'Network',
  },
  {
    icon: 'ri-lightbulb-line',
    title: 'ITコンサルティング',
    description: 'IT戦略の立案から導入支援まで、専門家の視点でビジネスの課題を分析。最適なITソリューションをご提案します。',
    color: 'from-yellow-300/20 to-yellow-300/5',
    tag: 'Consulting',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'システム保守・監視サービス',
    description: '24時間365日のシステム監視と迅速な障害対応で、ビジネスの継続性を確保。安心してシステムをお任せいただけます。',
    color: 'from-orange-300/20 to-orange-300/5',
    tag: 'Maintenance',
  },
];

export default function ServicesSection() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section id="services" className="py-24 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-yellow-400/5 rounded-full -translate-y-1/2 translate-x-1/2 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-yellow-400/5 rounded-full translate-y-1/2 -translate-x-1/2 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 relative z-10">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 border-2 border-yellow-400 rounded-full px-6 py-2 mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-settings-3-line text-yellow-500 text-sm"></i>
            </div>
            <span className="text-yellow-600 text-xs font-bold tracking-widest uppercase">Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" style={{ fontFamily: "'Montserrat', 'Noto Sans JP', sans-serif" }}>
            私たちのサービス
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            お客様のビジネスを加速させる6つのITソリューション
          </p>
        </div>

        {/* Service cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <div
              key={service.title}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              className={`relative rounded-2xl p-7 border transition-all duration-300 cursor-pointer group ${
                hovered === i
                  ? 'bg-yellow-400 border-yellow-400 -translate-y-2'
                  : 'bg-white border-gray-100 hover:border-yellow-200'
              }`}
              style={{ boxShadow: hovered === i ? '0 20px 40px rgba(255, 217, 61, 0.3)' : '0 2px 12px rgba(0,0,0,0.04)' }}
            >
              {/* Tag */}
              <span className={`absolute top-5 right-5 text-xs font-bold tracking-widest px-2 py-1 rounded-full ${
                hovered === i ? 'bg-black/10 text-black' : 'bg-gray-100 text-gray-400'
              }`}>
                {service.tag}
              </span>

              {/* Icon */}
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl mb-5 transition-all duration-300 ${
                hovered === i ? 'bg-black/10' : 'bg-gray-50'
              }`}>
                <i className={`${service.icon} text-2xl ${hovered === i ? 'text-black' : 'text-gray-700'}`}></i>
              </div>

              {/* Title */}
              <h3 className={`text-lg font-bold mb-3 leading-snug transition-colors duration-300 ${
                hovered === i ? 'text-black' : 'text-gray-900'
              }`}>
                {service.title}
              </h3>

              {/* Description */}
              <p className={`text-sm leading-relaxed transition-colors duration-300 ${
                hovered === i ? 'text-black/70' : 'text-gray-500'
              }`}>
                {service.description}
              </p>


            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
